module.exports = __webpack_public_path__ + "img/facial_hair_mustache_thick_mask.9e57baa2.png";